<template>
  <div v-if="localShow" class="modal-overlay" @click="closeModal">
    <div class="modal-dialog" @click.stop>
      <BaseDialog
        :title="'Create New Dataset'"
        :info="`New datasets are empty. Use the Import function to populate datasets.
          Before training, images should be split accordingly into train and validate(val) groups using the Import function.`"
        :footerButtons="['Cancel', 'Create']"
        @cancel="closeModal"
        @create="createDataset"
      >
        <div class="settings__control-group">
          <div class="input-label d-flex">
            <label class="required">Dataset Name</label>
            <SVGIcon
              v-tooltip="'It is recommended to give datasets a name can summarize what the data is or its purpose.'"
              :width="'20px'"
              :height="'20px'"
              :iconName="'info'"
              class="tooltip-icon"
            />
          </div>
          <input
            v-model="createNewName"
            class="select"
            type="text"
          >
        </div>

        <div class="settings__control-group">
          <div class="input-label d-flex">
            <label class="required">Annotation Set Name</label>
            <SVGIcon
              v-tooltip="`A dataset can have many annotation sets.
          Annotation sets are collections of annotations and sensor data (eg. 2D bounding boxes, 3D bounding boxes, Radar, LiDAR, etc.)
          that are used for training.`"
              :width="'20px'"
              :height="'20px'"
              :iconName="'info'"
              class="tooltip-icon"
            />
          </div>
          <input
            v-model="annSetName"
            class="select"
            placeholder="annotations"
          >
        </div>

        <div class="settings__control-group">
          <div class="input-label d-flex">
            <label>Labels</label>
            <SVGIcon
              v-tooltip="`Labels are image classes used by 2D bounding boxes, 3D bounding boxes, and segmentations.
                  Some common labels are suggested (person, car, bicycle). You can add new labels by
                  entering comma separated values. If this input field is blank, no labels will be created. You can always add more labels by clicking
                  the add icon in the 'Labels' section of the dataset card.
                `"
              :width="'20px'"
              :height="'20px'"
              :iconName="'info'"
              class="tooltip-icon"
            />
          </div>
          <textarea
            v-model="labels"
            placeholder="person,car,bicycle"
            rows="2"
            cols="50"
          />
        </div>

        <div class="settings__control-group">
          <div class="input-label d-flex">
            <label>Dataset Description</label>
            <SVGIcon
              v-tooltip="`Describe additional information useful for data curation, training, or validation.`"
              :width="'20px'"
              :height="'20px'"
              :iconName="'info'"
              class="tooltip-icon"
            />
          </div>
          <textarea
            v-model="createNewDescription"
            rows="2"
            cols="50"
          />
        </div>

        <div v-if="message" class="settings__control-group">
          <span class="warning">{{ message }}</span>
        </div>
      </BaseDialog>
    </div>
  </div>
</template>

<script>
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import BaseDialog from '@/components/DilaogTemplate/BaseDialog.vue';
import SVGIcon from '@/components/SVGIcon.vue';

export default {
  name: 'DatasetCreateModal',
  components: {
    BaseDialog,
    SVGIcon,
  },
  emits: {
    'create-dataset': null,
  },
  data() {
    return {
      dsConn: new DatastoreConnect(this.$store.state.enterpriseServerUrl),
      createNewName: '',
      createNewDescription: '',
      annSetName: 'annotations',
      labels: '',
      message: null,
      localShow: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
  },
  methods: {
    showModal() {
      this.localShow = true;
    },
    clearData() {
      this.createNewName = '';
      this.createNewDescription = '';
      this.labels = '';
      this.annSetName = 'annotations';
      this.message = null;
    },
    closeModal() {
      this.clearData();
      this.localShow = false;
    },
    createDataset() {
      if (!this.createNewName || this.createNewName === "") {
        this.message = 'Missing dataset name';
        return;
      }
      let l = [];
      if (this.labels && this.labels !== "") {
        l = this.labels.split(",");
      }
      l = l.map((e) => e.trim()).filter((e) => e !== "");
      const args = {
        name: this.createNewName,
        description: this.createNewDescription,
        annotation_set_name: this.annSetName,
        labels: l,
      };
      this.$emit('create-dataset', args);
      this.closeModal();
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(0, 0, 0, 0.45);
  z-index: 2000;
}

.modal-dialog {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>

